import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page_with_nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      class: "header",
      onToggleMenu: _ctx.toggleMenu
    }, null, 8, ["onToggleMenu"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.authStore.isLoggedIn)
        ? _renderSlot(_ctx.$slots, "left_menu", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideWhenClickMobile && _ctx.hideWhenClickMobile(...args)))
          }, undefined, true)
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass('page' + (_ctx.window.innerWidth > 750 ? ' with_nav' : '')),
        style: _normalizeStyle(!_ctx.authStore.isLoggedIn ? 'left: 0px': '')
      }, [
        _createElementVNode("div", {
          id: "menu_filter",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
        }),
        _createVNode(_component_RouterView)
      ], 6)
    ])
  ], 64))
}